import React, { Component } from 'react';
import { Table, Column } from 'components/Table';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';

import '../../../sass/components/ui-list';
import 'components/PupsquestMetricsPanel/pupsquestMetricsPanel.scss';
import PupsquestMetricsPanel from 'components/PupsquestMetricsPanel/PupsquestMetricsPanel';

import { keyedObjToArr } from '../../util/index';
import {LessonCell, HeaderCell, ReallyReadingCell, ReallyWritingCell, SoundBlendCell, SoundFarmCell,
    TraceRaceCell, WordBuilderCell, LessonHeaderCell} from './MetricsListCells';
import { PQ2MetricsListLegend } from './MetricsListLegend';
import {sortMetrics} from '../../util/metrics';

export class PQ2MetricsList extends Component {

    listenAndGrade (lesson) {
        let student;
        let classroom = keyedObjToArr(this.props.classrooms).find( (classroomItem) => {
            return classroomItem.id === this.props.classroomId;
        }, this);
        if(classroom) {
            student = keyedObjToArr(classroom.students).find((studentItem) => {
                return studentItem.id === this.props.studentId;
            }, this);
        }

        this.props.openDrawer(<PupsquestMetricsPanel
            customer={this.props.customer}
            student={student}
            classroom={classroom}
            lesson={lesson}
            editing={true}
            // users={this.props.users}
            // schools={this.props.schools}
            // products={this.props.products}
            // orders={this.props.orders}
        />);
    }

    constructor (props) {
        super(props);
        this.state = {
            showLegend: false,
        };
    }

    toggleLegend = () => {
        this.setState({ showLegend: !this.state.showLegend });
    }

	render () {
        // We're sorting otherwise lesson 10 appears beween 1 and 2
        let metrics = sortMetrics(this.props.student.metrics);
        return (
            <div className="main-list-area">
                <Table
                    data={metrics}
                    showLegend={this.state.showLegend}
                    legend={PQ2MetricsListLegend}
                >
                    <Column
                        header={<LessonHeaderCell
                            toggleLegend={this.toggleLegend}
                        />}
                        col="lesson"
                        className="narrow"
                        tooltip={true}
                        cell={<LessonCell/>}
                    />
                    <Column
                        header={<HeaderCell
                            text="Sound"
                            text2="Farm"
                        />}
                        col="soundfarm"
                        className="align-center"
                        tooltip={true}
                        cell={<SoundFarmCell/>}
                    />
                    <Column
                        header={<HeaderCell
                            text="Word"
                            text2="Builder"
                        />}
                        col="wordbuilder"
                        className="align-center"
                        tooltip={true}
                        cell={<WordBuilderCell/>}
                    />
                    <Column
                        header={<HeaderCell
                            text="Trace"
                            text2="Race"
                        />}
                        col="tracerace"
                        className="align-center"
                        tooltip={true}
                        cell={<TraceRaceCell/>}
                    />
                    <Column
                        header={<HeaderCell
                            text="Sound"
                            text2="Blend"
                        />}
                        col="soundblend"
                        className="align-center"
                        tooltip={true}
                        cell={<SoundBlendCell/>}
                    />
                    <Column
                        header={<HeaderCell
                            text="Really"
                            text2="Writing"
                        />}
                        col="reallywriting"
                        className="align-center"
                        tooltip={true}
                        cell={<ReallyWritingCell/>}
                    />
                    <Column
                        header={<HeaderCell
                            text="Really"
                            text2="Reading"
                        />}
                        col="reallyreading"
                        className="narrow"
                        tooltip={true}
                        cell={<ReallyReadingCell
                            student={this.props.student}
                            classroom={this.props.classroom}
                            listenAndGrade={this.listenAndGrade.bind(this)}
                        />}
                    />
                </Table>
            </div>
        );
    }
}




const mapDispatchToProps = (dispatch) => {
    return {
        openDrawer :  (id) => { dispatch(openDrawer(id)); },
        closeDrawer : () => { dispatch(closeDrawer()); },
        openModal : (modal, props) => { dispatch(openModal(modal, props)); }
    };
};

export default connect(null, mapDispatchToProps)(PQ2MetricsList);


// WEBPACK FOOTER //
// ./js/components/MetricsList/PQ2MetricsList.js